// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hsGprm {
  display: flex;
  align-items: stretch;
  width: 100%;
  background-color: #6db7d4 !important;
  min-height: 52px;
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
}
.jWpMhA {
  display: flex;
  align-items: stretch;
  width: 100%;
  /* background-color: rgb(255, 255, 255); */
  background-color: #6db7d4 !important;
  min-height: 52px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
`, "",{"version":3,"sources":["webpack://./src/Sidebar/Tickets/Itsupporttickets.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,oCAAoC;EACpC,gBAAgB;EAChB,wBAAwB;EACxB,wCAAwC;EACxC,0BAA0B;AAC5B;AACA;EACE,aAAa;EAEb,oBAAoB;EACpB,WAAW;EACX,0CAA0C;EAC1C,oCAAoC;EACpC,gBAAgB;EAChB,4CAA4C;AAC9C","sourcesContent":[".hsGprm {\r\n  display: flex;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  background-color: #6db7d4 !important;\r\n  min-height: 52px;\r\n  border-bottom-width: 1px;\r\n  border-bottom-color: rgba(0, 0, 0, 0.12);\r\n  border-bottom-style: solid;\r\n}\r\n.jWpMhA {\r\n  display: flex;\r\n  -webkit-box-align: stretch;\r\n  align-items: stretch;\r\n  width: 100%;\r\n  /* background-color: rgb(255, 255, 255); */\r\n  background-color: #6db7d4 !important;\r\n  min-height: 52px;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
